// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2ilgs","amount":"Amount_amount__1iqhA","tip":"Amount_tip__1Yu1d","tipHeader":"Amount_tipHeader__yG1bF","tipsWrap":"Amount_tipsWrap__2VQAD"};